var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsDate, IsInt, IsString, IsUUID, ValidateNested } from 'class-validator';
export class AvailableSlotTreatmentDto {
    treatmentId;
    duration;
    therapistIds;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], AvailableSlotTreatmentDto.prototype, "treatmentId", void 0);
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], AvailableSlotTreatmentDto.prototype, "duration", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], AvailableSlotTreatmentDto.prototype, "therapistIds", void 0);
export class AvailableSlotDto {
    start;
    compatibleTreatments;
}
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], AvailableSlotDto.prototype, "start", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => AvailableSlotTreatmentDto),
    __metadata("design:type", Array)
], AvailableSlotDto.prototype, "compatibleTreatments", void 0);
//# sourceMappingURL=available-slot.dto.js.map